<template>
  <router-layout>
    <div class="mybox">
      <div class="myGroup3 flex-col" :style="{ background: 'url(' + $store.state.app.qiniuHostUrl + 'myBack.png' + ') no-repeat center center' }">
        <div class="myInfo">
          <div class="myMod1 flex-row">
            <!-- <img class="myGroup4" :src="head_img" alt=""> -->
            <div class="myGroup4 flex-col" :style="{ background: 'url(' + head_img + ') no-repeat center center' }"></div>
          </div>
          <div class="mainInfo">
            <div class="myMod2 flex-row">
              <span class="myTxt1 van-ellipsis">{{ data && data.nickName ? data.nickName : '未填写' }}</span>
              <div class="renzheng renzheng1" v-if="type == 1 && approveOrNot == 0" @click="toRenzheng(0)">去认证</div>
              <div class="renzheng renzheng2" v-if="type == 1 && approveOrNot == -1" @click="toRenzheng(-1)">未通过</div>
              <div class="renzheng renzheng3" v-if="type == 1 && approveOrNot == 1" @click="toRenzheng(1)">认证中</div>
              <div class="renzheng renzheng4" v-if="type == 1 && approveOrNot == 2" @click="toRenzheng(2)">已认证</div>
            </div>
            <div class="myMod3 flex-row">
              <span class="myInfo2">手机号：{{ data && data.mobile }}</span>
            </div>
          </div>
          <div class="rightTop">
            <img class="myLabel1" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'my_info_a.png'" @click="toUserInfo" />
          </div>
        </div>
        
      </div>
      <div id="qrCodeContent" ref="qrcodeWrapper" style="display:none"></div>
      <div class="myGroup5 flex-col" :style="{height:is_app?BDh5height:BDappheight}">
        <div class="myGroup6 flex-col">
          <div class="myBd2 flex-row" @click="toPage(2)">
            <div class="myBd01">
              <img class="myLabel2" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'per_info.png'" />
              <span class="myWord4">基本信息</span>
            </div>
            <div>
              <span class="toComplete" v-if="!ifFillInfo">去完善</span>
              <span class="toComplete" v-if="ifTobeUpdate">去更新</span>
              <img class="myLabel3" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'arrow_a.png'" />
            </div>
          </div>
          <div class="myBd3 flex-col"></div>
          <div class="myBd4 flex-row" @click="toPage(3)">
            <div class="myBd01"><img class="myIcon4" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'my_icon1_a.png'" />
            <span class="myInfo3">我的关注</span></div>
            <img class="myLabel3" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'arrow_a.png'" />
          </div>
          <div class="myBd3 flex-col"></div>
          <div class="myBd4 flex-row" @click="toPage(4)">
            <div class="myBd01"><img class="myIcon4" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'my_icon2_a.png'" />
            <span class="myInfo3">我的收藏</span></div>
            <img class="myLabel3" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'arrow_a.png'" />
          </div>

          <div class="myBd3 flex-col"></div>
          <div class="myBd4 flex-row" @click="toPage(8)">
            <div class="myBd01"><img class="myIcon4" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'my_icon6_a.png'" />
            <span class="myInfo3">我的病例</span></div>
            <img class="myLabel3" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'arrow_a.png'" />
          </div>

          <div class="myBd3 flex-col"></div>
          <div class="myBd4 flex-row" @click="toPage(5)">
            <div class="myBd01"><img class="myIcon4" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'my_icon4_a.png'" />
            <span class="myInfo3">浏览记录</span></div>
            <img class="myLabel3" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'arrow_a.png'" />
          </div>

          <div class="myBd3 flex-col" v-if="invateFriendShow"></div>
          <div class="myBd4 flex-row" v-if="invateFriendShow" @click="toPage(7)">
            <div class="myBd01"><img class="myIcon4" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'invte邀请好友icon@3x.png'" />
            <span class="myInfo3">邀请好友</span></div>
            <img class="myLabel3" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'arrow_a.png'" />
          </div>

          <div class="myBd3 flex-col"></div>
          <div class="myBd4 flex-row" @click="toPage(6)">
            <div class="myBd01"><img class="myIcon4" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'my_icon5_a.png'" />
            <span class="myInfo3">联系客服</span></div>
            <img class="myLabel3" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'arrow_a.png'" />
          </div>

          <div class="myBd3 flex-col"></div>
          <div class="myBd4 flex-row" @click="to_down" v-show="!is_app">
            <div class="myBd01"><img class="myIcon4" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'down_icon.png'" />
            <span class="myInfo3">APP下载</span></div>
            <div><img class="myLabel3" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'arrow_a.png'" /></div>
          </div>

          <div class="myBd3 flex-col" v-show="!is_app"></div>
          <div class="myBd4 flex-row" @click="togeneralsetting">
            <div class="myBd01"><img class="myIcon4" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'my_generalsetting.png'" />
            <span class="myInfo3">通用设置</span></div>
            <div><img class="myLabel3" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'arrow_a.png'" /></div>
          </div>
          
          <div class="myBd3 flex-col"></div>
          <div class="myBd4 flex-row" @click="exit">
            <div class="myBd01"><img class="myIcon4" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'exit.png'" />
            <span class="myInfo3">退出登录</span></div>
            <div><img class="myLabel3" referrerpolicy="no-referrer" :src="$store.state.app.qiniuHostUrl + 'arrow_a.png'" /></div>
          </div>

        </div>
        <dir class="cancel" @click="showCancelDia = true">注销</dir>
        
      </div>
      
      <!-- <Item :data="tabbarDes" @change="getVal" :sel="selected" :ifFillInfo="ifFillInfo"> </Item> -->
    </div>
    <van-popup class="dialog" v-model="showCancelDia">
        <div class="loginSpan">请拨打电话 021-64360386 注销账号,我们将在7个工作日内为您处理。</div>
				<div class="loginBtn" @click="showCancelDia = false">我知道了</div>
    </van-popup>
    <van-popup v-model="showExit" :style="{ height: '195px', width: '320px', borderRadius: '8px' }">
      <div class="loginoutMsg">
        <div>确定要退出此次登录？</div>
      </div>
      <div class="loginoutBtns">
        <!-- <div @click="toExit"></div> -->
        <button class="van-hairline--top van-hairline--right" @click="toExit">确定</button>
        <button class="van-hairline--top" @click="cancelExit">取消</button>
      </div>
    </van-popup>
    
  </router-layout>
</template>

<script>
import { getStore, is_app, setStore, urlShare, compareVer } from '../assets/js/utils'
import TIM from 'tim-js-sdk'
import TIMUploadPlugin from 'tim-upload-plugin'
let options = {
  SDKAppID: Number(process.env.VUE_APP_IMAPP) // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
}
// 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
let tim = TIM.create(options) // SDK 实例通常用 tim 表示
// 设置 SDK 日志输出级别，详细分级请参见 <a href="https://web.sdk.qcloud.com/im/doc/zh-cn//SDK.html#setLogLevel">setLogLevel 接口的说明</a>
tim.setLogLevel(0) // 普通级别，日志量较多，接入时建议使用
// tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用
// 注册腾讯云即时通信 IM 上传插件
tim.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin })
import '../assets/css/common.css'
// import Item from '../compnents/Item.vue'
import { maidianP } from '../assets/js/maidian'
import QRCode from 'qrcodejs2'
import { Dialog } from 'vant'
export default {
  name: 'My',
  components: {
    // Item
  },
  data() {
    return {
      selected: 'my',
      show: false,
      is_hz: true,
      head_img: '',
      tabbarDes: [
        {
          page: '',
          normalImg: this.$store.state.app.qiniuHostUrl + 'icon1_nol_a.png',
          activeImg: this.$store.state.app.qiniuHostUrl + 'icon1_act_a.png'
        },
        {
          page: 'my',
          normalImg: this.$store.state.app.qiniuHostUrl + 'icon2_nol_a.png',
          activeImg: this.$store.state.app.qiniuHostUrl + 'icon2_act_a.png'
        }
      ],
      data: {},
      userID: '',
      userSig: '',
      is_app: is_app(),
      // is_needCom: true,
      type: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).identity : 1,
      ifFillInfo: true,
      share: {},
      showCancelDia: false,
      showExit: false,
      fromfullname: '',
      pre_page_name: '',
      approveOrNot: -2,
      loginConfiguration: getStore('loginConfiguration'),
      dialogCon: getStore('dialogCon'),
      qrcodeUrl: '',    //二维码url
      isVersionPopShow: true, //是否展示低版本弹窗
      invateFriendShow: true, //是否展示邀请好友
      BDappheight: '620px',
      BDh5height: '560px',
      ifTobeUpdate: false
    }
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from.path);
    next((vm) => {
      vm.fromfullname = from.fullPath
      vm.pre_page_name = from.meta.title
    })
  },
  mounted() {
    // console.log('is_app', is_app())
    console.log(this.$store.state)
    this.share = {
      title: document.title,
      link: urlShare(),
      imgUrl: this.$store.state.app.qiniuHostUrl + 'login_logo.png'
    }
    this.$wxshare(this.share)
    localStorage.setItem('share', JSON.stringify(this.share))
    console.log(this.$store, this.$store.state.user)
    this.baseInfo()
    this.getPopShowJson()
    if (this.$store.state.user.identity === '') {
      this.show = true
    }
    
  },
  methods: {
    // 获取邀请码json
    async getPopShowJson() {
      let res = await this.$api.PopShowJson()
      if (res) {
        this.isVersionPopShow = res.isPopShow
        let versionCode = localStorage.getItem('versionCode')
        if (!versionCode) {
					versionCode = '2.0.5'
				}
        let versionVer = compareVer(versionCode,'2.0.6')
        if (versionVer == -1) {
          if (!this.isVersionPopShow) {
            // 弹窗隐藏
            this.invateFriendShow = false
            this.BDappheight = '500px'
            this.BDh5height = '440px'
          }
        }
      }
    },
    //生成二维码
    generateQrCode() {
      return new Promise((resolve) => {
        let container = document.getElementById('qrCodeContent')
        // 清空之前的二维码，如果不清空，再次执行方法会有两张图片
        if (container.innerHTML) {
          container.innerHTML = ''
        }
        let width = document.documentElement.clientWidth*(192/375)
        let height = width
        let qrcode = new QRCode(container, {
          text: this.qrcodeUrl,        //二维码扫描后展示内容
          width: width,
          height: height,
          colorDark: '#C76DD6',
          colorLight: '#fff',
          correctLevel: QRCode.CorrectLevel.H  //二维码的纠错等级
        })
        console.log(qrcode)
        // 创建logo
        let logo = new Image()
        logo.crossOrigin = 'Anonymous'
        logo.src = this.$store.state.app.qiniuHostUrl + '20230526-150526.png'
        // 生成logo图
        logo.onload = () => {
          // 获取二维码
          const img = this.$refs.qrcodeWrapper.querySelector("img");
          const canvas = document.getElementsByTagName("canvas")[0];
          let ctx = canvas.getContext('2d')
          // 写入logo
          ctx.drawImage(logo,width*0.5 - 22,height*0.5 -22,44,44)
          img.src = canvas.toDataURL("image/png",1)
          resolve(img.src)
        }
      })
    },
    async toUserInfo() {
      await this.$api.aliyunHzMD({
        ...maidianP('pv-my_1'),
        funname: this.$route.fullPath,
        fromfullname: this.fromfullname
      })
      this.$api.aliyunHzMD({
        ...maidianP('rare_IconClick'),
        fromfullname: this.fromfullname,
        funname: this.$route.fullPath,
        pre_page_name: this.pre_page_name,
        icon_name: '我的-个人信息（右上角）'
      })
      this.$router.push('/Userinfo')
    },
    async toPage(type) {
      let contentName = ''
        switch (type) {
          case 2:
            contentName = '我的-基本信息'
            break;
          case 3:
            contentName = '我的-我的关注'
            break
          case 4:
            contentName = '我的-我的收藏'
            break
          case 5:
            contentName = '我的-浏览记录'
            break
          case 6:
            contentName = '我的-联系客服'
            break
          case 7:
            contentName = '我的-邀请好友'
            break
          case 8:
            contentName = '我的-我的病例'
            break
          default:
            break
        }
        await this.$api.aliyunHzMD({
          ...maidianP('pv-my_' + type),
          fromfullname: this.fromfullname,
          funname: this.$route.fullPath
        })
        this.$api.aliyunHzMD({
          ...maidianP('rare_IconClick'),
          fromfullname: this.fromfullname,
          funname: this.$route.fullPath,
          pre_page_name: this.pre_page_name,
          icon_name: contentName
        })
        if (type == 2) {
          this.$router.push('/completeInfo/' + this.type +'?from=my')
        } else if (type == 3) {
          this.$router.push('/Focus')
        } else if (type == 4) {
          this.$router.push('/Collection')
        } else if (type == 5) {
          this.$router.push('/Historicalrecord')
        } else if (type == 6) {
          this.$router.push('/Connect')
        } else if (type == 7) {
          // 邀请好友
          if (this.is_app) {
            let versionCode = localStorage.getItem('versionCode')
            let versionVer = compareVer(versionCode,'2.0.6')
            if (versionVer == -1) {
              // 旧版本
              if (this.isVersionPopShow) {
                // 展示弹窗
                Dialog.alert({
                  message: '当前版本过低，请升级到最新版本。',
                  confirmButtonColor: '#9931E2'
                }).then(() => {
                  // on close
                });
              }
            } else {
              // 大于2.0.6版本
              window.nativefun('popInviteUserDialog', {}, (data) => {
              // 拿到type类型的值，获取点击的按钮类型
              // 1微信、2朋友圈、3下载二维码
                let dataType = JSON.parse(data)
                if (dataType.type == 3) {
                  // 下载二维码
                  this.invitationCode(2)
                } else if (dataType.type == 2) {
                  this.invitationCode(1)
                  // 朋友圈
                } else if (dataType.type == 1) {
                  this.invitationCode(0)
                  // 微信
                }
              })
            }
          } else {
            // 非app打开
            // 获取邀请码
            this.invitationCode(3)
          }
        } else if (type == 8) {
          this.$router.push('/MyCase')
        }
    },
    // 获取邀请码
    async invitationCode (invitationType) {
      const res = await this.$api.invitationCode({
        invitationType
      })
      if (res === false && !res) return
      let userInfo = getStore('userInfo')
      this.qrcodeUrl = 'https://' + window.location.host + '/hr/download/' + res.invitationCode + '/' + userInfo.userId
      this.$api.aliyunHzMD({
        ...maidianP('rare_InviteFriends'),
          funname: this.$route.fullPath,
          fromfullname: this.fromfullname,
          page_name: document.title,
          pre_page_name: this.pre_page_name,
          invite_type: invitationType == 0 ? '分享微信好友' : invitationType == 1 ? '分享朋友圈' : invitationType == 2 ? 'app保存二维码' : '非app保存二维码',
          invite_code: res.invitationCode,
          invite_useruuid: userInfo.userId,
      })
      if (invitationType == 2) {
        // app
        // 下载二维码
        this.generateQrCode().then(result => {
          window.nativefun('downloadPic',
            {
              type: 2,
              pic: result
            },() =>{
              // ...
            }
          );
        })
      } else if (invitationType == 3) {
        // 微信邀请好友
        this.generateQrCode().then(result => {
          // 跳转二维码页
          this.$router.push({
            name: 'invataTwoCode',
            query: {
              codeBase64: result,
              invitationCode: res.invitationCode,
              invitationUserId: userInfo.userId
            },
          })
        })
      } else {
        // 微信、朋友圈
        window.nativefun('setInviteUserParam',{
          title: '下载罕见病新进展APP，学习罕见病规范化诊疗知识。',
          text: '您的好友邀请您一起来学习！点击立即下载APP。',
          image: this.$store.state.app.qiniuHostUrl + 'login_logo.png',
          url: this.qrcodeUrl
        },() =>{
          // ...
        })
      }
    },
    getVal(val) {
      console.log(val)
    },
    async exit() {
      await this.$api.aliyunHzMD({
        ...maidianP('pv-my_9'),
        funname: this.$route.fullPath,
        fromfullname: this.fromfullname
      })
      this.$api.aliyunHzMD({
        ...maidianP('rare_IconClick'),
        fromfullname: this.fromfullname,
        funname: this.$route.fullPath,
        pre_page_name: this.pre_page_name,
        icon_name: '我的-退出登录'
      })
      this.showExit = true
    },
    async cancelExit() {
      await this.$api.aliyunHzMD({
        ...maidianP('pv-loginout-2'),
        fromfullname: this.fromfullname,
        funname: this.$route.fullPath
      })
      this.$api.aliyunHzMD({
        ...maidianP('rare_IconClick'),
        fromfullname: this.fromfullname,
        funname: this.$route.fullPath,
        pre_page_name: this.pre_page_name,
        icon_name: '我的-取消退出登录'
      })
      this.showExit = false
    },
    async toExit() {
      await this.$api.aliyunHzMD({
        ...maidianP('pv-loginout-1'),
        funname: this.$route.fullPath,
        fromfullname: this.fromfullname
      })
      this.$api.aliyunHzMD({
        ...maidianP('rare_IconClick'),
        fromfullname: this.fromfullname,
        funname: this.$route.fullPath,
        pre_page_name: this.pre_page_name,
        icon_name: '我的-确定退出登录'
      })
      this.getSig()
      if (localStorage.getItem('cid')) {
        var cid = localStorage.getItem('cid')
      }
      let traceId = localStorage.getItem('TraceId')
      let KYCenter = getStore('KYCenter')
      this.$store.commit('LOGIN_OUT')
      localStorage.clear()
      this.$toast('退出成功')
      setStore('loginConfiguration', this.loginConfiguration)
      setStore('dialogCon', this.dialogCon)
      setStore('TraceId', traceId)
      setStore('KYCenter', KYCenter)
      if (cid) {
        setStore('cid', cid)
      }
      setTimeout(() => {
        this.$router.push('/')
      }, 2000)
    },
    async getSig() {
      const res = await this.$api.getSig({
        userId: ''
      })
      this.userID = res.userId
      this.userSig = res.sig
      console.log(res)
      this.logout()
      console.log(res.userId, res.sig, '用户idd')
    },
    logout() {
      let res = tim
        .logout({
          userID: this.userID,
          userSig: this.userSig
        })
        .then((res) => {
          if (res.code === 0) {
            this.Group()
            return this.editMyProfile()
          }
        })
      console.log(res, '登录完成')
    },
    go() {
      this.$router.push({ name: 'Collection', params: { id: 1 } })
    },
    async baseInfo() {
      const res = await this.$api.baseInfo({})
      if (res === false && !res) return
      this.data = res
      if (this.data && !this.data.portraitUrl) {
        this.head_img = this.$store.state.app.qiniuHostUrl + 'initPort.jpeg'
      } else {
        this.head_img = this.data.portraitUrl
      }
      setStore('userInfo', res)
      this.ifFillInfo = res.auths.ifFillIn
      this.ifTobeUpdate = res.auths.ifTobeUpdate ? res.auths.ifTobeUpdate : false
      this.approveOrNot = res.auths.approveOrNot
      // setStore('approveOrNot', this.approveOrNot)
      // setStore('ifFillInfo', this.ifFillInfo)
      
      // console.log(this.ifFillInfo)
    },
    async to_down() {
      await this.$api.aliyunHzMD({
        ...maidianP('pv-my_7'),
        fromfullname: this.fromfullname,
        funname: this.$route.fullPath
      })
      this.$api.aliyunHzMDUrl({
        ...maidianP('rare_AppDownloadPage'),
        fromfullname: this.fromfullname,
        funname: this.$route.fullPath,
        pre_page_name: this.pre_page_name,
        channel_id: ''
      }).then(() => {
        window.location.href = 'https://static-object.hjbxjz.com/app.html'
      })
    },
    // 通用设置
    togeneralsetting() {
      this.$api.aliyunHzMDUrl({
        ...maidianP('rare_IconClick'),
        fromfullname: this.fromfullname,
        funname: this.$route.fullPath,
        pre_page_name: this.pre_page_name,
        icon_name: '我的-通用设置'
      }).then(() => {
        this.$router.push('/generalSetting')
      })
    },
    toRenzheng(state) {
      this.$api.aliyunHzMD({
        ...maidianP('pv-my_10'),
        // fromfullname: this.fromfullname,
					funname: this.$route.fullPath
      })
      this.$api.aliyunHzMD({
        ...maidianP('rare_IconClick'),
        funname: this.$route.fullPath,
        pre_page_name: this.pre_page_name,
        icon_name: '我的-去认证'
      })
      if (state == 0) {
        this.$router.push('/Step1')
      } else {
        this.$router.push('/CertificationResult'+ '?state=' + state)
      }
      
    }
  }
}
</script>
<style scoped>
.header {
  width: 100vw;
  height: 44px;
  text-align: center;
  margin-bottom: 0.5px;
  margin: 0 auto 0.5px;
}
.headertitter {
  line-height: 44px;
  font-size: 21px;
}
.myPage {
  z-index: 1;
  position: relative;
  width: 100vw;
  height: 812px;
  background-color: rgba(255, 255, 255, 1);
  overflow: hidden;
  justify-content: flex-end;
  padding-bottom: 0;
}

.myGroup1 {
  z-index: auto;
  width: 100vw;
  height: 797px;
}

.myMain1 {
  z-index: auto;
  width: 340px;
  height: 18px;
  margin-left: 21px;
}

.myWord1 {
  z-index: 18;
  width: 54px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 1);
  font-size: 15px;
  letter-spacing: -0.30000001192092896px;
  font-family: Helvetica;
  line-height: 18px;
  text-align: center;
}

.myicon1 {
  z-index: 12;
  width: 17px;
  height: 11px;
  margin: 3px 0 0 219px;
}

.myBd1 {
  z-index: 8;
  width: 16px;
  height: 11px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb3bbe96fea0140cfc24043ebc96677b3c6566f6cd0b99cb137439fb58271c764) 0px 0px no-repeat;
  margin: 3px 0 0 5px;
}

.myIcon2 {
  z-index: 4;
  width: 25px;
  height: 12px;
  margin: 2px 0 0 4px;
}

.myMain2 {
  z-index: 20;
  height: 44px;
  align-self: center;
  margin-top: 11px;
  width: 100vw;
  justify-content: center;
  align-items: center;
}

.myWord2 {
  z-index: 22;
  width: 36px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(69, 69, 86, 1);
  font-size: 18px;
  font-family: PingFangSC-Regular;
  line-height: 28px;
  text-align: justify;
}

.myMain3 {
  z-index: 21;
  width: 100vw;
  height: 1px;
  background-color: rgba(229, 229, 232, 1);
  align-self: center;
}

.myMain4 {
  z-index: 23;
  height: 723px;
  background-color: rgba(244, 244, 250, 1);
  align-self: center;
  width: 100vw;
  justify-content: flex-end;
}

.box1 {
  z-index: 123;
  height: 50px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px -2px 6px 0px rgba(243, 240, 245, 1);
  width: 100vw;
}

.block1 {
  z-index: auto;
  width: 100vw;
  height: 50px;
  justify-content: space-between;
}

.section1 {
  z-index: 137;
  height: 50px;
  width: 187px;
  justify-content: center;
  align-items: center;
}

.myMain5 {
  z-index: auto;
  width: 24px;
  height: 38px;
}

.myMain6 {
  z-index: 140;
  width: 24px;
  height: 24px;
  /* background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng1bf36cbf5f334134a62d563a0f9665a5f7b2c42d6b23d225331a9cb63bd1a28a) -2px 0px no-repeat; */
  align-self: center;
}

.word3 {
  z-index: 147;
  width: 20px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(173, 173, 194, 1);
  font-size: 10px;
  font-family: PingFangSC-Regular;
  line-height: 14px;
  text-align: center;
  align-self: center;
}

.section2 {
  z-index: 126;
  height: 50px;
  width: 187px;
  justify-content: center;
  align-items: center;
}

.wrap1 {
  z-index: auto;
  width: 24px;
  height: 38px;
}

/* .group2 {
  z-index: 129;
  width: 24px;
  height: 24px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng89e790b9b1180aee44c58cc9ac22021b31f90d9e4bf9da9c9ac43532f242ca6d) -3px -2px
    no-repeat;
  align-self: center;
} */

.info1 {
  z-index: 134;
  width: 20px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(90, 17, 165, 1);
  font-size: 10px;
  font-family: PingFangSC-Regular;
  line-height: 14px;
  text-align: center;
  align-self: center;
}

.myGroup3 {
  z-index: 24;
  height: 280px;
  /* background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngf8c511f2b6219de77abc43c129eba98131fd62945e7c5b338177b6ee285eb780) 100% no-repeat; */
  width: 100vw;
  position: absolute;
  left: 0;
  background-size: 100vw 280px !important;
  /* top: 88px; */
}

.myInfo {
  height: 131px;
  display: flex;
}

.mainInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.myMod1 {
  z-index: auto;
  width: 80px;
  height: 80px;
  justify-content: space-between;
  position: relative;
  margin-top: 27px;
  margin-left: 28px;
  margin-right: 16px;
}

.myGroup4 {
  z-index: 44;
  width: 80px;
  height: 80px;
  margin: 0 auto;
  box-shadow: 0px 0px 0px 6px rgba(97, 28, 204, 0.5) inset;
  border-radius: 45px;
  background-size: cover !important;
}

.rightTop {
  width: 24px;
  height: 24px;
}

.myLabel1 {
  z-index: 34;
  width: 24px;
  height: 24px;
  /* margin-top: 14px; */
  position: absolute;
  right: 16px;
  top: 21px;
}

.myMod2 {
  z-index: auto;
  /* width: 180px; */
  line-height: 28px;
  height: 25px;
  margin: 4px 0px;
  /* margin-top: 35px; */
}

.myTxt1 {
  z-index: 42;
  display: block;
  max-width: 180px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  font-family: PingFangSC-Medium;
  line-height: 28px;
  /* text-align: justify; */
  /* text-align: center; */
}

.myMod3 {
  z-index: auto;
  width: 100%;
  text-align: center;
  height: 18px;
  /* margin: 2px 0 0 119px; */
}

.myInfo2 {
  z-index: 43;
  /* width: 137px; */
  display: block;
  overflow-wrap: break-word;
  color: #B89EE1;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  line-height: 20px;
  text-align: justify;
  width: 100%;
  /* text-align: center; */
}

.myGroup5 {
  z-index: 99;
  height: 385px;
  /* background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng316ce927cfa02e1ee8d5a0c2915f7e997dba69c8a01c972d7784fdc925bd83df) -8px -6px no-repeat; */
  /* width: 335px; */
  width: calc(100vw - 40px);
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  position: absolute;
  left: 20px;
  top: 131px;
  /* transform: translateX(-167px); */
  padding: 24px 15px 0 0;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0px 2px 8px #E3E3E8;
}
.myGroup6 {
  z-index: auto;
  width: calc(100% - 22px);
  /* height: 269px; */
}
.myBd2 {
  display: flex;
  justify-content: space-between;
  z-index: auto;
  width: 100%;
  height: 24px;
  margin-left: 4px;
}
.myLabel2 {
  z-index: 53;
  width: 24px;
  height: 24px;
}
.myWord4 {
  z-index: 60;
  /* width: 64px; */
  display: block;
  /* overflow-wrap: break-word; */
  white-space: nowrap;
  color: rgba(47, 47, 70, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular;
  line-height: 22px;
  text-align: left;
  margin: 1px 0 0 12px;
}
.myIcon3 {
  z-index: 50;
  width: 24px;
  height: 24px;
  /* margin-left: 173px; */
  float: right;
}
.myBd3 {
  z-index: 62;
  width: 100%;
  height: 1px;
  background-color: #F0F0F3;
  align-self: flex-start;
  margin-top: 18px;
}
.myBd4 {
  display: flex;
  justify-content: space-between;
  z-index: auto;
  width: 100%;
  height: 24px;
  margin: 18px 0 0 4px;
}
.myBd01 {
  display: flex;
}
.myIcon4 {
  z-index: 73;
  width: 24px;
  height: 24px;
}
.myInfo3 {
  z-index: 78;
  /* width: 64px; */
  display: block;
  /* overflow-wrap: break-word; */
  white-space: nowrap;
  color: rgba(47, 47, 70, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular;
  line-height: 22px;
  text-align: left;
  margin: 1px 0 0 12px;
}
.myLabel3 {
  z-index: 70;
  width: 24px;
  height: 24px;
  /* margin-left: 173px; */
  
}
.myBd5 {
  z-index: 64;
  width: 295px;
  height: 1px;
  background-color: rgba(240, 240, 243, 1);
  align-self: flex-start;
  margin: 18px 0 0 1px;
}
.myBd6 {
  z-index: auto;
  width: 297px;
  height: 25px;
  margin: 18px 0 0 4px;
}
.myLabel4 {
  z-index: 83;
  width: 24px;
  height: 24px;
}
.myWord5 {
  z-index: 94;
  /* width: 80px; */
  display: block;
  /* overflow-wrap: break-word; */
  white-space: nowrap;
  color: rgba(47, 47, 70, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular;
  line-height: 22px;
  text-align: left;
  margin: 1px 0 0 12px;
}
.myLabel5 {
  z-index: 80;
  width: 24px;
  height: 24px;
  margin: 1px 0 0 157px;
}
.myBd7 {
  z-index: 66;
  width: 295px;
  height: 1px;
  background-color: rgba(240, 240, 243, 1);
  align-self: flex-start;
  margin: 18px 0 0 1px;
}
.myBd8 {
  z-index: auto;
  width: 297px;
  height: 24px;
  margin: 18px 0 0 4px;
}
.myLabel6 {
  z-index: 99;
  width: 24px;
  height: 24px;
}
.myWord6 {
  z-index: 108;
  /* width: 64px; */
  display: block;
  /* overflow-wrap: break-word; */
  white-space: nowrap;
  color: rgba(47, 47, 70, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular;
  line-height: 22px;
  text-align: left;
  margin: 1px 0 0 12px;
}
.myIcon5 {
  z-index: 96;
  width: 24px;
  height: 24px;
  margin-left: 173px;
}
.myBd9 {
  z-index: 68;
  width: 295px;
  height: 1px;
  background-color: rgba(240, 240, 243, 1);
  align-self: flex-start;
  margin: 18px 0 0 1px;
}
.myBd10 {
  z-index: auto;
  width: 297px;
  height: 24px;
  margin: 18px 0 0 4px;
}
.myLabel7 {
  z-index: 113;
  width: 24px;
  height: 24px;
}
.myWord7 {
  z-index: 121;
  /* width: 64px; */
  display: block;
  /* overflow-wrap: break-word; */
  white-space: nowrap;
  color: rgba(47, 47, 70, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular;
  line-height: 22px;
  text-align: left;
  margin: 1px 0 0 12px;
}
.myIcon6 {
  z-index: 110;
  width: 24px;
  height: 24px;
  margin-left: 173px;
}

.mybox {
  width: 100vw;
  height: 850px;
  background: #f4f4fa;
  overflow-y: auto;
}
.pop_box {
  overflow: hidden;
  border-radius: 8px;
}
.pop {
  width: 300px;
  height: 210px;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;

  position: relative;
}
.pop_title {
  margin-top: 39px;
  font-size: 18px;
  color: #454556;
  font-weight: 500;
  text-align: center;
}
.pop_btn {
  width: 180px;
  margin: 0 auto;
  margin-top: 25px;
  display: flex;
  justify-content: space-between;
}
.pop_btn > div {
  width: 80px;
  height: 28px;
  border-radius: 20px;
  text-align: center;
  line-height: 28px;
}
.comm_btn {
  width: 182px;
  height: 32px;
  line-height: 32px;
  margin: 0 auto;
  margin-top: 35px;
  text-align: center;
  font-size: 15px;
  color: #fff;
  background: linear-gradient(180deg, #8051ed 0%, #7927cd 100%);
  border-radius: 16px;
}
.next {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 13px;
  color: #cacad8;
}
.toComplete {
  color: #F11D5F;
  font-size: 14px;
  position: relative;
  top: -7px;
  left: -3px;
  font-family: PingFangSC-Regular;
}
.cancel {
  padding: 0;
  margin: 38px auto;
  color: #CACAD8;
  
}

.dialog {
	width: 320px;
	height: 195px;
	border-radius: 8px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	font-size: 16px;
	box-sizing: border-box;
	padding: 0px 24px;

}
.loginSpan {
		line-height: 24px;
		color: #454556;
		margin-bottom: 32px;
	}
	.loginBtn {
    display: flex;
    justify-content: center;
    align-items: center;
		width: 160px;
		height: 40px;
		border-radius: 20px;
		background-color: #7A1DD9;
		color: #fff;
	}
  >>>.van-overlay {
    width: 100vw;
    height: 100vh;
    
  }
  .loginoutMsg {
    font-size: 18px;
    line-height: 24px;
    height: 130px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #454556;
  }
  .loginoutBtns {
    display: flex;
    height: 64px;
    width: 100%;
    font-size: 17px;
    line-height: 24px;
  }
  .loginoutBtns button {
    /* div { */
    height: 100%;
    width: 50%;
    /* border: 1px solid #ECECEF; */
    /* } */
  }
  .loginoutBtns :nth-child(1) {
    color: #ADADC2;
  }
  .loginoutBtns :nth-child(2) {
    color: #7A1DD9;
  }
  /* >>>.van-hairline--right::after {
    border: 1px solid #ECECEF;
    border-top-width: 1px;
  } */
  .renzheng {
    margin-left: 8px;
    margin-top: 4px;
    width: 56px;
    height: 20px;
    box-shadow: 0px 2px 8px 0px rgba(184,66,108,0.4100);
    border-radius: 10px;
    
    color: #fff;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    line-height: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .renzheng1, .renzheng2, .renzheng3 {
    background-color: #F42465F2;
  }
  .renzheng4 {
    background-color: #2AB597;
  }

</style>
